/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'exportDrawSystemGameTypeReportByCompositeKey',
    message: messages.SUCCESS_EXPORT_DRAW_SYSTEM_GAME_TYPE_REPORT_BY_COMPOSITE_KEY,
    method: 'POST',
    path: '/draw-system-game-type-report/:compositeKey/export',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.EXPORT_DRAW_SYSTEM_GAME_TYPE_REPORT,
    requestSchema: requestSchemas.drawSystemGameTypeReports.exportDrawSystemGameTypeReportByCompositeKey,
  },
  {
    action: 'getDrawSystemGameTypeReportByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_REPORT_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw-system-game-type-report/:compositeKey',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_REPORT,
    requestSchema: requestSchemas.drawSystemGameTypeReports.getDrawSystemGameTypeReportByCompositeKey,
  },
];
